import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './ProductDetailPage.css';

const ProductDetailPage = () => {

  const [selectedImage, setSelectedImage] = useState(null); // Для модального окна
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Текущий индекс изображения в модальном окне
  const { id } = useParams(); // Получаем ID из URL
  const [product, setProduct] = useState(null);
  const [remainingTime, setRemainingTime] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`/api/products/${id}`);
        setProduct(response.data.product); // Устанавливаем данные продукта
        setRemainingTime(response.data.remainingTime); // Устанавливаем оставшееся время
        setIsLoading(false); // Убираем состояние загрузки
      } catch (err) {
        console.error('Ошибка загрузки данных:', err);
        setError('Ошибка загрузки данных. Попробуйте позже.');
        setIsLoading(false);
      }
    };

    fetchProduct();
  }, [id]);



  const renderStatus = (status, statusExpiration) => {
    if (!statusExpiration) {
      return <p><strong>Статус: </strong>{status} (Бессрочный)</p>;
    }

    const expirationDate = new Date(statusExpiration);
    const remainingTime = expirationDate - Date.now();

    if (remainingTime > 0) {
      const daysRemaining = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
      return <p><strong>Статус: </strong>{status} (Осталось {daysRemaining} дней)</p>;
    }

    return <p><strong>Статус: </strong>{status} (Истек)</p>;
  };

  if (!product) {
    return <div>Загрузка...</div>;
  }
  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index); // Установить текущий индекс
  };

  const closeModal = () => {
    setSelectedImage(null); // Закрыть модальное окно
  };

  const handlePrevImage = () => {
    const imagesArray = [product.mainImage, ...product.images];
    const prevIndex = (currentImageIndex - 1 + imagesArray.length) % imagesArray.length;
    setSelectedImage(imagesArray[prevIndex]);
    setCurrentImageIndex(prevIndex);
  };

  const handleNextImage = () => {
    const imagesArray = [product.mainImage, ...product.images];
    const nextIndex = (currentImageIndex + 1) % imagesArray.length;
    setSelectedImage(imagesArray[nextIndex]);
    setCurrentImageIndex(nextIndex);
  };

  if (error) {
    return <div>{error}</div>;
  }

  if (!product) {
    return <div>Загрузка...</div>;
  }


  const { title, description, district, mainImage, images, prices, characteristics, preferences, phone } = product;

  const priceLabels = {
    priceOneHour: 'Цена за 1 час',
    priceTwoHours: 'Цена за 2 часа',
    priceTravelOneHour: 'Цена за поездку (1 час)',
    priceTravelTwoHours: 'Цена за поездку (2 часа)',
    priceWholeNight: 'Цена за ночь',
  };



  return (
    <div className="product-detail">
      <h2>{title}</h2>


      <div className="product-detail__header">
        {/* {renderStatus(product.status, product.statusExpiration)} */}
        {/* Описание */}
        <div className="product-detail__description">
          <h4>Описание:</h4>
          <p>{description}</p>
          <p>Район: {characteristics.district || 'Не указан'}</p>
        </div>
        {/* Контактная информация */}
        <div className="product-detail__contact">
          <h4>Контактная информация:</h4>
          <div className="contact-buttons">
            <p>{phone}</p>
            <a href={`tel:${phone}`} className="btn contact-btn call-btn">
              Позвонить
            </a>
            <a
              href={`https://wa.me/${phone.replace('+', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn contact-btn whatsapp-btn"
            >
              Написать
            </a>
          </div>
        </div>


      </div>

      <div className="product-detail__main">
        {/* Галерея изображений */}
        <div className="product-detail__gallery">
          {images &&
            images.length > 0 &&
            images.map((image, index) => (
              <img
                key={index}
                src={`/uploads/${image}`}
                alt={`Дополнительное изображение ${index + 1}`}
                className="product-detail__thumbnail"
                onClick={() => handleImageClick(image, index + 1)} // Индекс сдвигается на 1
              />
            ))}
        </div>
        {/* Основное изображение */}
        <div className="product-detail__image">
          <img
            src={`/uploads/${mainImage}`}
            alt="Основное изображение"
            onClick={() => handleImageClick(mainImage, 0)}
          />
        </div>


        {/* Информация о продукте */}
        <div className="product-detail__info">
          {/* Характеристики */}
          <div className="product-detail__characteristics">
            <h4>Характеристики:</h4>
            <p>
              <span style={{ color: "red", fontWeight: "bold" }}>Возраст:</span> <strong>{characteristics.age} лет</strong>
            </p>
            <p>
              <span style={{ color: "red", fontWeight: "bold" }}>Рост:</span> <strong>{characteristics.height} см</strong>
            </p>
            <p>
              <span style={{ color: "red", fontWeight: "bold" }}>Вес:</span> <strong>{characteristics.weight} кг</strong>
            </p>
            <p>
              <span style={{ color: "red", fontWeight: "bold" }}>Грудь:</span> <strong>{characteristics.breast} размер</strong>
            </p>

          </div>
          {/* Цены */}
          <div className="product-detail__prices">
            <h4>Цены:</h4>
            <ul>
              {Object.entries(prices).map(([key, value]) => (
                <li key={key}>
                  <span style={{ color: "red", fontWeight: "bold" }}>

                    {priceLabels[key] || key}:
                  </span>{" "}
                  <strong>{value} ₽.</strong>
                </li>
              ))}
            </ul>
          </div>
          {/* Предпочтения */}
          <div className="product-detail__preferences">
            <h4>Предпочтения:</h4>
            {preferences &&
              Object.keys(preferences).map((category) => (
                <div key={category}>
                  <strong>
                    <span style={{ color: "black", fontWeight: "bold" }}>{category} :</span>
                  </strong>
                  <ul>
                    {preferences[category]?.options?.map((pref, index) => (
                      <li key={index}>
                        <span style={{ color: "red", fontWeight: "bold" }}>{pref}</span>
                        {preferences[category]?.prices?.[pref]
                          ? <> - ₽: <strong>{preferences[category].prices[pref]}</strong></>
                          : ' входит'
                        }
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
          </div>


        </div>

      </div>



      {/* Модальное окно для просмотра изображений */}
      {selectedImage && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-prev" onClick={handlePrevImage}>
              &#9664;
            </button>
            <img src={`/uploads/${selectedImage}`} alt="Просмотр изображения" />
            <button className="modal-next" onClick={handleNextImage}>
              &#9654;
            </button>
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetailPage;
